<template>
  <div :class="$style.wrap">
    <template v-if="rule">
      <div :class="$style.instructions" v-html="rule"></div>
      <div :class="$style.opration">
        <van-button
          :class="$style.apply"
          round
          type="primary"
          size="large"
          tag="input"
          native-type="submit"
          value="申请开票"
          @click.stop.prevent="submitHandler"
        />
      </div>
      <van-dialog
        :before-close="closeDialog"
        v-model="show"
        title="手机号验证"
        show-cancel-button
      >
        <div :class="$style.dialog_content">
          <div :class="$style.dialog_tip">
            请使用手机号{{ phone }}获取验证码
          </div>
          <base-form
            ref="form"
            :locked="true"
            :has-captcha="false"
            label-width="2em"
            :items.sync="data"
            @submit="submitForm"
            @getData="getData"
          />
        </div>
      </van-dialog>
    </template>
  </div>
</template>
<script>
import { getInvoiceInfo, checkPhone } from "@/http/invoice";
import BaseForm from "@/components/BaseForm";
export default {
  name: "invoiceRules",
  components: {
    BaseForm
  },
  data() {
    return {
      data: [
        {
          name: "iconPhoneCode",
          type: 4,
          moduleType: true
        }
      ],
      phone: "",
      show: false,
      rule: ""
    };
  },
  mounted() {
    this.removeSession();
    this.getInfo();
  },
  methods: {
    removeSession() {
      this.$ls.remove("gameList");
      this.$ls.remove("timeList");
      this.$ls.remove("gameActive");
      this.$ls.remove("timeActive");
    },
    getData(index, value) {
      this.$set(this.data[index], "value", value);
    },
    async getInfo() {
      let res = await getInvoiceInfo();
      if (res.data) {
        const { notice, s_security_telphone } = res.data;
        this.rule = notice;
        this.phone = s_security_telphone;
      }
    },
    async submitForm(formdata) {
      let res = await checkPhone({
        type: 4,
        code: formdata.iconPhoneCode
      });
      if (res.rcode === 0) {
        this.$set(
          this.data,
          0,
          Object.assign({}, this.data[0], {
            value: ""
          })
        );
        this.$router.replace({ path: this._anchor.invoiceQuery.path });
        this.show = false;
      } else if (res.rcode === 3001) {
        this.$router.replace({
          path: this._anchor.invoiceResult.path,
          query: {
            type: 3,
            time: res.data
          }
        });
      }
    },
    closeDialog(action, done) {
      if (action === "confirm") {
        this.$refs.form.submitHandler();
        done(false);
      } else {
        this.$refs.form.handlerSendNum();
        this.$set(
          this.data,
          0,
          Object.assign({}, this.data[0], {
            value: ""
          })
        );
        done();
      }
    },
    submitHandler() {
      if (this.phone.length === 0) {
        this.$Dialog
          .confirm({
            title: "您还未绑定手机，暂无法申请发票开票。",
            message: "是否去绑定手机号？",
            confirmButtonText: "立即绑定",
            cancelButtonText: "我知道了"
          })
          .then(() => {
            this.$router.replace({
              path: this._anchor.verifier.path
            });
          })
          .catch(() => {});
        return false;
      }
      this.show = true;
    }
  }
};
</script>
<style lang="less" module>
:global {
  html #app,
  body #app {
    height: 100%;
  }
  #app {
    & > div {
      height: 100%;
    }
  }
  .van-cell::after,
  .van-cell:not(:last-child)::after {
    border-bottom: 0;
  }
  .van-dialog {
    width: auto;
    min-width: 320px;
  }
}
.wrap {
  position: relative;
  height: calc(100% - 1.1rem);
  padding: 1.1rem 0.3rem 0rem 0.3rem;
}
.instructions {
  height: calc(100% - 1.5rem);
  overflow-y: scroll;
  font-size: 0.28rem;

  a {
    color: blue;
    text-decoration: underline;
  }
  h3 {
    text-align: center;
  }
  span {
    color: #c20707;
  }
  p {
    margin-bottom: 0.2rem;
  }
  div {
    float: right;
    p {
      font-size: 0.28rem;
    }
    p:last-child {
      text-align: center;
    }
  }
}
.apply {
  margin: 0 auto;
  display: block;
}

.opration {
  width: 7rem;
  z-index: 9;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
}
.dialog_content {
  padding: 0.4rem 0 0.2rem 0;
}
.dialog_tip {
  padding: 0 0.5rem 0.2rem 0.5rem;
}
</style>
